module.exports = __webpack_public_path__ + "static/media/whatsappForForm.83a5decd.svg";